import React from 'react';
import Loader from 'ui/Loader/Loader';

const LoaderForTable = () => (
  <div>
    <Loader size={60} />
  </div>
);

export default LoaderForTable;
